module.exports = __webpack_public_path__ + "media/images/company-071c2153111745525d6ccbbcc13e6ae3.svg";